import React from "react";
import { Link } from "react-router-dom";

const RecomendacionCard = ({ recomendacion }) => {
  return (
    <div className="card">
      <img src={recomendacion.imagen} alt={recomendacion.titulo} className="card-image" />
      <div className="card-body">
        <h3 className="card-title">{recomendacion.titulo}</h3>
        <p className="card-description">{recomendacion.descripcionCorta}</p>
        <Link
          to={`/recomendacion/${recomendacion.slug}`}
          className="card-button"
        >
          Ver más
        </Link>
      </div>
    </div>
  );
};

export default RecomendacionCard;